var map = {
	"./andre_bolini.jpg": 156,
	"./aurea_carolina.jpg": 157,
	"./cristal_lopez.jpg": 158,
	"./denys_grellmann.jpg": 159,
	"./diogo_pastorello.jpg": 160,
	"./dremerson.jpg": 161,
	"./eduardo_suplicy.jpg": 162,
	"./francisco_junior.jpg": 163,
	"./goura.jpg": 164,
	"./hendel_machado.jpg": 165,
	"./jose_police_neto.jpg": 166,
	"./luciana_santos.jpg": 167,
	"./margarida_salomao.jpg": 168,
	"./pedro_markun.jpg": 169,
	"./ricardo_tripoli.jpg": 170,
	"./ricardo_young.jpg": 171,
	"./tarcisio_secoli.jpg": 172
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos nonrecursive \.jpg$
// module id = 155
// module chunks = 0